import { Component, OnDestroy, OnInit } from '@angular/core';

import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { AuthService } from '@auth/auth.service';
import { DataService } from '@data/data.service';

@Component({
  selector: 'app-change-facility-dialog',
  templateUrl: './change-facility-dialog.component.html',
  styleUrls: ['./change-facility-dialog.component.scss'],
})
export class ChangeFacilityDialogComponent implements OnInit, OnDestroy {
  destroy$ = new Subject<void>();

  constructor(public dataService: DataService, public authService: AuthService) {}

  ngOnInit() {
    this.authService.changeFacilityDialog$
      .pipe(
        filter((x) => !!x),
        takeUntil(this.destroy$)
      )
      .subscribe((x) => this.dataService.hideScreen$.next(!!x));
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  public showDialog(show: boolean = true) {
    this.authService.changeFacilityDialog$.next(show);
    this.dataService.hideScreen$.next(show);
  }
}
